<template>
  <div class="px-6 cursor-pointer text-bc-blue underline" @click="showImage(0)">
    OPEN GALLERY WITH MODAL ({{ totalImages }}x)
  </div>

  <div class="AwGallery" v-if="showModal">
    <div class="AwGalleryHeader">
      <div class="flex-1 truncate pr-2">Foto #{{ currentIndex + 1 }}</div>
      <div class="space-x-5 text-gray-500">
        <aw-icon
          icon="download"
          class="w-5 h-5  cursor-pointer hover:text-gray-200"
          @click="download()"
        />
        <aw-icon
          icon="comment-empty"
          class="w-5 h-5  cursor-pointer hover:text-gray-200"
        />
        <aw-icon
          icon="info"
          class="w-5 h-5  cursor-pointer hover:text-gray-200"
          @click="info()"
        />
        <aw-icon
          icon="close"
          class="w-5 h-5  cursor-pointer hover:text-gray-200"
          @click="closeImage()"
        />
      </div>
    </div>

    <div class="AwGallery__Pic">
      <span class="AwGallery__PicWrapper">
        <img :src="currentImage" @click.stop="" style="opacity: 1" />

        <div
          v-if="currentIndex === 0"
          class="w-6 h-6 absolute"
          style="top: 10%; left: 25%"
        >
          <gallery-comment pos="1" />
        </div>

        <div
          v-if="currentIndex === 0"
          class="w-6 h-6 absolute"
          style="top: 16%; right: 35%"
        >
          <gallery-comment pos="2" />
        </div>

        <div
          v-if="currentIndex === 0"
          class="w-6 h-6 absolute"
          style="top: 36%; right: 23%"
        >
          <gallery-comment pos="3" />
        </div>

        <div
          v-if="currentIndex === 0"
          class="w-6 h-6 absolute"
          style="top: 76%; right: 60%"
        >
          <gallery-comment pos="4" />
        </div>
      </span>
    </div>

    <div class="AwGalleryThumbs">
      <img
        v-for="(image, index) in images"
        :key="index"
        @click="showImage(index)"
        :src="image"
        :class="{ ThumbActive: index === currentIndex }"
        alt=""
      />
    </div>

    <span
      v-show="totalImages > 1"
      @click.stop="prevImage()"
      class="AwGallery__Prev"
      ><svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 24 24"
      >
        <title>chevron-left</title>
        <g
          stroke-linejoin="miter"
          stroke-linecap="square"
          stroke-width=".5"
          fill="none"
          stroke="#fff"
        >
          <path d="M14 18l-6-6 6-6"></path>
        </g>
      </svg>
    </span>

    <span
      v-show="totalImages > 1"
      @click.stop="nextImage()"
      class="AwGallery__Next"
      ><svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 24 24"
      >
        <title>chevron-right</title>
        <g
          stroke-linejoin="miter"
          stroke-linecap="square"
          stroke-width=".5"
          fill="none"
          stroke="#fff"
        >
          <path d="M10 6l6 6-6 6"></path>
        </g></svg
    ></span>
  </div>
</template>

<script>
import $ from 'cash-dom'

export default {
  props: {},
  data() {
    return {
      currentImage: null,
      currentIndex: null,
      showModal: false,
      images: [
        'https://picsum.photos/id/1010/1920/1080',
        'https://picsum.photos/id/1004/600/480',
        'https://picsum.photos/id/1022/1024/1600',
        'https://picsum.photos/id/1024/800/600',
        'https://picsum.photos/id/1011/600/800',
        'https://picsum.photos/id/1012/1024/800',
        'https://picsum.photos/id/1013/800/1024',
        'https://picsum.photos/id/102/1000/1600',
        'https://picsum.photos/id/1020/600/480',
        'https://picsum.photos/id/1021/600/480',
        'https://picsum.photos/id/1023/600/480',
        'https://picsum.photos/id/1024/600/480',
        'https://picsum.photos/id/1025/600/480',
        'https://picsum.photos/id/1026/600/480',
        'https://picsum.photos/id/1027/600/480',
        'https://picsum.photos/id/1028/600/480',
        'https://picsum.photos/id/1029/600/480',
        'https://picsum.photos/id/1031/600/480',
        'https://picsum.photos/id/1032/600/480',
        'https://picsum.photos/id/1033/600/480',
        'https://picsum.photos/id/1040/600/480',
        'https://picsum.photos/id/1041/600/480',
        'https://picsum.photos/id/1042/600/480',
        'https://picsum.photos/id/1043/600/480',
        'https://picsum.photos/id/1044/600/480',
        'https://picsum.photos/id/1045/600/480',
        'https://picsum.photos/id/1047/600/480',
        'https://picsum.photos/id/1048/600/480',
        'https://picsum.photos/id/1050/600/480',
        'https://picsum.photos/id/1051/600/480',
        'https://picsum.photos/id/1052/600/480',
        'https://picsum.photos/id/1053/600/480',
        'https://picsum.photos/id/1054/600/480',
        'https://picsum.photos/id/1055/600/480',
        'https://picsum.photos/id/1056/600/480'
      ]
    }
  },
  computed: {
    totalImages() {
      return this.images.length
    },
    imagesThumbs() {
      const thumbs = this.images.filter((imgObj, index) => {
        return index > 0
      })
      return thumbs
    },
    styles() {
      return (
        'background: url(' + this.currentImage + ') no-repeat center / contain;'
      )
    }
  },
  methods: {
    download() {
      !!window.open(this.currentImage)
    },
    showImage(index) {
      this.showModal = true
      this.currentIndex = index
      this.currentImage = this.images[index]
      this.scrollPane()
    },
    prevImage() {
      if (this.currentIndex === 0) {
        this.showImage(this.totalImages - 1)
      } else {
        this.showImage(this.currentIndex - 1)
      }
    },
    nextImage() {
      if (this.currentIndex >= this.totalImages - 1) {
        this.showImage(0)
      } else {
        this.showImage(this.currentIndex + 1)
      }
    },
    info() {
      window.alert('some info about picture ...')
    },
    closeImage() {
      this.showModal = false
      this.currentIndex = null
      this.currentImage = null
    },
    scrollPane() {
      const move = this.currentIndex * -(48 + 16)
      $('.AwGalleryThumbs').css('margin-left', move)
    }
  },
  mounted() {
    document.addEventListener('keydown', (e) => {
      if (!this.showModal) return

      if (e.key === 'Escape') {
        this.closeImage()
      }
      if (e.key === 'ArrowLeft') {
        this.prevImage()
      }

      if (e.key === 'ArrowRight') {
        this.nextImage()
      }
    })
  }
}
</script>

<style lang="scss">
.AwGallery {
  background: rgba(#000, 0.75);
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.AwGalleryHeader {
  @apply fixed bg-gray-800 text-white flex items-center top-0 left-0 right-0 h-10 px-4;
  z-index: 10005;
}

.AwGallery__Pic {
  position: fixed;
  //width: calc(100% - 150px);
  left: 75px;
  right: 75px;
  top: 40px;
  bottom: 60px;
  text-align: center;
  @apply flex items-center justify-center;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.AwGallery__PicWrapper {
  @apply relative;
  @apply inline-flex;
  @apply h-full;
}

.AwGallery__Prev {
  position: fixed;
  z-index: 1000;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 75px;
  cursor: pointer;
}

.AwGallery__Next {
  position: fixed;
  z-index: 1000;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 75px;
  cursor: pointer;
}

.AwGalleryThumbs {
  @apply fixed bottom-2 left-0 right-0;
  @apply h-12;
  @apply overflow-hidden;
  @apply whitespace-nowrap;
  transition: 100ms 50ms;
}

.AwGalleryThumbs img {
  @apply w-12 h-12 opacity-50 cursor-pointer;
  @apply mr-4;
  transition: 100ms 50ms;
}
.AwGalleryThumbs img.ThumbActive {
  @apply opacity-100;
}
</style>
